import type { CmsApiPagePost } from '#/modules/cms/api/types/CmsApiPage';
import { CommentButton } from '#/modules/cms/components/Reactions/CmsReactionsCommentButton';
import { ShareButton } from '#/modules/cms/components/Reactions/CmsReactionsShareButton';

export function CmsButtonBar({ content }: { content: CmsApiPagePost }) {
  return (
    <>
      {content.enableComments ? <CommentButton /> : null}
      {content.hasSocialSharing ? <ShareButton content={content} /> : null}
    </>
  );
}
